<div class="card-header bg-light">
    <h3 class="card-title mb-0">
        <i *ngIf="this.id && !visualizar" class="fas fa-pencil-alt pr-2"></i>
        <i *ngIf="this.id && visualizar" class="fas fa-search pr-2"></i>
        <i *ngIf="!this.id" class="far fa-file pr-2"></i>
        {{ tituloModal }}
    </h3>
</div>

<div class="card-body wrapper">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm">
        <div class="row mb-2">
            <div class="col-md-2 mb-2">
                <label for="inputIdentificador" class="mb-1">Constatação</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputIdentificador" class="form-control form-control-sm" readonly
                        [ngModel]="model.identificador" [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
            <div class="col-md-10 mb-2">
                <label for="inputTitulo" class="mb-1">Título</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputTitulo" class="form-control form-control-sm" readonly
                        [ngModel]="model.titulo" [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar" class="input-group-append">
                        <button type="button" class="btn btn-info" (click)="exibirModalConstatacao()"
                            title="Buscar uma constatação já cadastrada">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-success ml-1" (click)="cadastrarConstatacao()"
                            title="Cadastrar uma nova constatação">
                            <i class="fas fa-plus"></i> Adicionar
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputDescricao" class="mb-1">Descrição</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <textarea id="inputDescricao" class="form-control form-control-sm" rows="3" name="descricao"
                        readonly [ngModel]="model.descricao" [ngModelOptions]="{standalone: true}">
                    </textarea>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputTipo" class="mb-1">Tipo</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputTipo" class="form-control form-control-sm" readonly
                        [ngModel]="model.tipoDesc" [ngModelOptions]="{standalone: true}" />
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputCriteriosInfrigidos" class="mb-1">Critérios Infrigidos</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <textarea id="inputCriteriosInfrigidos" class="form-control form-control-sm" rows="3"
                        name="criteriosInfrigidos" readonly [ngModel]="model.criteriosInfrigidos"
                        [ngModelOptions]="{standalone: true}">
                    </textarea>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputSituacaoEncontrada" class="mb-1">Situação Encontrada</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <textarea id="inputSituacaoEncontrada" class="form-control form-control-sm" rows="3"
                        name="situacaoEncontrada" [(ngModel)]="model.situacaoEncontrada"
                        [ngModelOptions]="{standalone: true}" [readonly]="visualizar" maxlength="500">
                    </textarea>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputEvidencia" class="mb-1">Evidências Vinculadas</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar" type="text" id="inputEvidenciaSel" class="form-control form-control-sm"
                        readonly [ngModel]="evidenciaSelecionada?.osaExecucaoPapelTrabalho?.nomePapel"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar" class="input-group-append">
                        <button type="button" class="btn btn-info" (click)="exibirModalEvidencia()"
                            title="Buscar evidência">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-success ml-1" (click)="addEvidencia()"
                            title="Adicionar a evidência selecionada na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceEvidencias" matSortDisableClear matSort
                        matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['nome', 'arquivo', 'link', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="nome">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Nome do Papel de Trabalho
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.osaExecucaoPapelTrabalho.nomePapel">-</span>
                                <span *ngIf="element?.osaExecucaoPapelTrabalho.nomePapel">{{
                                    element.osaExecucaoPapelTrabalho.nomePapel }}</span>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="arquivo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Arquivos</th>
                            <td mat-cell *matCellDef="let element">
                                <a class="icon-btn btn btn-info btn-xs text-left ml-1" data-toggle="collapse"
                                    href="#collapseExample-{{element?.arquivos[0]?.id}}" role="button"
                                    aria-expanded="false">
                                    Arquivos
                                    <i class="ml-2 fas fa-file"></i>
                                </a>

                                <div class="collapse" id="collapseExample-{{ element.arquivos[0]?.id }}">
                                    <small *ngIf="!element?.arquivos[0]" class="ml-1"> Não possui arquivos</small>
                                    <div *ngFor="let items of element?.arquivos" class="ml-1">
                                        <div class="">
                                            <small (click)="
                                                                    download(items?.osaExecucaoPapelTrabalhoArquivo)
                                                                " class="download">{{
                                                items.osaExecucaoPapelTrabalhoArquivo.nome
                                                }}</small>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="link">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Link
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span *ngIf="!element?.osaExecucaoPapelTrabalho.link">-</span>
                                <span *ngIf="element?.osaExecucaoPapelTrabalho.link">{{
                                    element.osaExecucaoPapelTrabalho.link }}</span>
                            </td>
                        </ng-container>

                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirEvidencia(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['nome', 'arquivo', 'link', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceEvidencias.data?.length > 0">
                        Nenhuma evidência vinculada
                    </h5>
                    <mat-paginator #tabelaEvidenciaPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputRiscos" class="mb-1">Riscos Associados</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar" type="text" id="inputRiscoSel" class="form-control form-control-sm"
                        readonly
                        [ngModel]="isQuestaoIncidental? riscoSelecionadoQI?.descricao: riscoSelecionado?.descricaoRisco"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar" class="input-group-append">
                        <button type="button" class="btn btn-info"
                            (click)="isQuestaoIncidental? exibirModalRiscoQI() : exibirModalRisco()"
                            title="Buscar risco">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-success ml-1"
                            (click)="isQuestaoIncidental? addRiscoQI(): addRisco()"
                            title="Adicionar o risco selecionado na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-2" *ngIf="!isQuestaoIncidental && !visualizar">
                <label for="inputNovoRisco" class="mb-1">Novo Risco</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputNovoRisco" class="form-control form-control-sm"
                        [(ngModel)]="novoRiscoDescricao" [ngModelOptions]="{standalone: true}"
                        placeholder="Digite a descrição do novo risco" />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-success" (click)="addRiscoAvulso()"
                            title="Adicionar novo risco">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceRiscos" matSortDisableClear matSort matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{
                                isQuestaoIncidental
                                ? (element?.osaExecucaoProgramaTrabalhoQuestaoIncidentalRisco?.descricao || '-')
                                : (element?.matrizRiscoControleRiscos?.descricaoRisco || element?.descricaoRiscoAvulso
                                || '-')
                                }}
                            </td>
                        </ng-container>
                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirRisco(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceRiscos.data?.length > 0">
                        Nenhuma risco vinculado
                    </h5>
                    <mat-paginator #tabelaRiscoPaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <label for="inputControles" class="mb-1">Controles Associados</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input [hidden]="visualizar" type="text" id="inputControleSel" class="form-control form-control-sm"
                        readonly
                        [ngModel]="isQuestaoIncidental? controleSelecionadoQI?.descricao: controleSelecionado?.descricao"
                        [ngModelOptions]="{standalone: true}" />
                    <div [hidden]="visualizar" class="input-group-append">
                        <button type="button" class="btn btn-info"
                            (click)="isQuestaoIncidental? exibirModalControleQI() : exibirModalControle()"
                            title="Buscar controle">
                            <i class="fas fa-search"></i>
                        </button>
                        <button type="button" class="btn btn-success ml-1"
                            (click)="isQuestaoIncidental? addControleQI() : addControle()"
                            title="Adicionar o controle selecionado na lista">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-2" *ngIf="!isQuestaoIncidental && !visualizar">
                <label for="inputNovoControle" class="mb-1">Novo Controle</label>
                <div class="input-group input-group-sm" style="width: 100%;">
                    <input type="text" id="inputNovoControle" class="form-control form-control-sm"
                        [(ngModel)]="novoControleDescricao" [ngModelOptions]="{standalone: true}"
                        placeholder="Digite a descrição do novo controle" />
                    <div class="input-group-append">
                        <button type="button" class="btn btn-success" (click)="addControleAvulso()"
                            title="Adicionar novo controle">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-md-12 mb-2">
                <div class="mat-elevation-z1">
                    <table mat-table [dataSource]="dataSourceControles" matSortDisableClear matSort
                        matSortDirection="asc">
                        <tr mat-header-row *matHeaderRowDef="['descricao', 'actions']" class="bg-light">
                        </tr>

                        <ng-container matColumnDef="descricao">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                Descrição
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{
                                isQuestaoIncidental
                                ? (element?.osaExecucaoProgramaTrabalhoQuestaoIncidentalControle?.descricao || '-')
                                : (element?.matrizRiscoControleAssociados?.descricao || element?.descricaoControleAvulso
                                || '-')
                                }}
                            </td>
                        </ng-container>
                        <ng-container cdkColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef class="text-center">
                                Ações
                            </th>
                            <td mat-cell *matCellDef="let element; let i = index" class="text-center">
                                <div class="d-flex justify-content-center align-items-center">
                                    <button type="button" class="btn btn-danger btn-xs ml-1" title="Excluir"
                                        *ngIf="!visualizar" (click)="excluirControle(i)">
                                        <i class="far fa-trash-alt"></i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-row *matRowDef="let row; columns: ['descricao', 'actions']"></tr>
                    </table>
                    <h5 class="table-no-data" [hidden]="dataSourceControles.data?.length > 0">
                        Nenhuma controle vinculado
                    </h5>
                    <mat-paginator #tabelaControlePaginator="matPaginator" [pageSizeOptions]="[5, 10, 15]"
                        showFirstLastButtons>
                    </mat-paginator>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="card-footer">
    <div class="d-flex justify-content-between w-100">
        <div class="btn-group" [hidden]="visualizar">
            <button class="btn btn-primary btn-sm mr" (click)="salvar()">
                <i class="far fa-save"></i> Salvar
            </button>
        </div>
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()" [hidden]="visualizar">
            <i class="fas fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="fechar()" [hidden]="!visualizar">
            <i class="fas fa-times"></i> Sair
        </button>
    </div>
</div>